import moment from 'moment';
import _ from 'lodash';
import { EmptyStates } from './constants';
import { isMenuEmpty } from './MenuUtils';
import { getSupportedDeliveryTypes } from './OrderUtils';
import { openrestHelpers } from '@wix/wixrest-utils';

const StatusHelper = openrestHelpers.Status;
export const NO_ADDRESS = '[noskip]';
export const DEFAULT_ADDRESS = '500 Terry A Francois Boulevard, San Francisco, CA 94158, United States number = 500';

function isOLOoff(organization) {
  const calendar = new moment().tz(organization.timezone);
  const availability = _.get(organization, 'orders.availability');
  if (calendar !== undefined && availability !== undefined) {
    const oloStatus = StatusHelper.getStatus(availability, calendar);
    if (oloStatus.status === 'unavailable' && oloStatus.until > Number.MAX_SAFE_INTEGER) {
      return true;
    }
  } else {
    return false;
  }
}

export function getEmptyState({ organization, simplifiedMenu }) {
  const { locale, timezone, address } = organization;
  const isPremium = Boolean(_.find(organization.products, p => p.param === 'premium'));

  if (!isPremium) {
    return EmptyStates.NO_PREMIUM;
  } else if (isMenuEmpty({ simplifiedMenu, locale, timezone })) {
    return EmptyStates.NO_MENU;
  } else if (isOLOoff(organization)) {
    return EmptyStates.OLO_OFF;
  } else if (_.isEmpty(getSupportedDeliveryTypes(organization))) {
    return EmptyStates.OLO_UNAVAILABLE;
  } else if (_.isEmpty(organization.paymentTypes)) {
    return EmptyStates.NO_PAYMENTS;
  } else if (address.formatted === NO_ADDRESS || address.formatted === DEFAULT_ADDRESS) {
    return EmptyStates.NO_REST_ADDRESS;
  } else {
    return null;
  }
}